module.exports = __webpack_public_path__ + "img/pluto45.28350484.jpg";